var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "12" } },
        [
          _c(
            "card",
            { staticClass: "stacked-form" },
            [
              _vm.isLoading
                ? _c("l-progress", {
                    staticClass: "mb-2",
                    attrs: {
                      value: 100,
                      height: 20,
                      type: "info",
                      animated: true,
                      striped: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { md: "12" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "success",
                            to: "/barang/ubah-harga/" + _vm.$route.params.id
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "money-bill" }
                          }),
                          _vm._v(" Ubah Harga")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: !_vm.addProduct ? "primary" : "warning"
                          },
                          on: {
                            click: function($event) {
                              _vm.addProduct = !_vm.addProduct
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: !_vm.addProduct ? "plus" : "times" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                !_vm.addProduct
                                  ? "Tambah Warna Barang"
                                  : "Batal"
                              )
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.addProduct
                ? _c(
                    "b-row",
                    { staticClass: "mt-5 mb-5" },
                    [
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c(
                          "form",
                          {
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.doSubmit($event)
                              }
                            }
                          },
                          [
                            _vm._l(_vm.lines, function(line, index) {
                              return _c(
                                "b-row",
                                {
                                  key: index,
                                  staticClass: "border ml-0 mr-0 mb-5 mt-3"
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "5" } },
                                    [
                                      _c(
                                        "fg-input",
                                        { attrs: { label: "Warna" } },
                                        [
                                          _c("treeselect", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              placeholder: "Pilih warna",
                                              multiple: false,
                                              "clear-on-select": true,
                                              options: _vm.colorList,
                                              name: "color",
                                              "data-vv-as": "color"
                                            },
                                            model: {
                                              value: line.color,
                                              callback: function($$v) {
                                                _vm.$set(line, "color", $$v)
                                              },
                                              expression: "line.color"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "5" } },
                                    [
                                      _c(
                                        "fg-input",
                                        { attrs: { label: "Ukuran" } },
                                        [
                                          _c("treeselect", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              placeholder: "Pilih ukuran",
                                              multiple: true,
                                              "clear-on-select": true,
                                              options: _vm.sizeList,
                                              name: "size",
                                              "data-vv-as": "size"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.getData(line.size, index)
                                              }
                                            },
                                            model: {
                                              value: line.size,
                                              callback: function($$v) {
                                                _vm.$set(line, "size", $$v)
                                              },
                                              expression: "line.size"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      attrs: { md: "1 p-0 mt-4-5 text-center" }
                                    },
                                    [
                                      index >= 1
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-danger",
                                              on: {
                                                click: function($event) {
                                                  _vm.removeLine(index)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      attrs: { md: "1 p-0 mt-4-5 text-center" }
                                    },
                                    [
                                      index + 1 === _vm.lines.length
                                        ? _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                type: "button",
                                                variant: "primary"
                                              },
                                              on: { click: _vm.addLine }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "plus" }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    _vm._l(line.model, function(
                                      lineSize,
                                      lineIndex
                                    ) {
                                      return _c(
                                        "b-row",
                                        { key: lineIndex },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { md: "12" } },
                                            [
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4 pl-4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input":
                                                            "capitalPrice",
                                                          type: "number",
                                                          name: "capitalPrice",
                                                          id: "capitalPrice",
                                                          label: "Harga Beli",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "capitalPrice"
                                                          ),
                                                          "data-vv-as":
                                                            "harga beli"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.capitalPrice,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "capitalPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.capitalPrice"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input":
                                                            "sellingPrice",
                                                          type: "number",
                                                          name: "sellingPrice",
                                                          id: "sellingPrice",
                                                          label: "Harga Jual",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "sellingPrice"
                                                          ),
                                                          "data-vv-as":
                                                            "harga jual"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.sellingPrice,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "sellingPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.sellingPrice"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input":
                                                            "memberPrice",
                                                          type: "number",
                                                          name: "memberPrice",
                                                          id: "memberPrice",
                                                          label: "Harga Member",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "memberPrice"
                                                          ),
                                                          "data-vv-as":
                                                            "harga member"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.memberPrice,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "memberPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.memberPrice"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4 pl-4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input":
                                                            "smPrice",
                                                          type: "number",
                                                          name: "smPrice",
                                                          id: "smPrice",
                                                          label:
                                                            "Harga spesial member",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "smPrice"
                                                          ),
                                                          "data-vv-as":
                                                            "harga sepesial member"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.smPrice,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "smPrice",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.smPrice"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input": "more3",
                                                          type: "number",
                                                          name: "more3",
                                                          id: "more3",
                                                          label:
                                                            "Harga lebih dari 3",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "more3"
                                                          ),
                                                          "data-vv-as":
                                                            "harga lebih dari 3"
                                                        },
                                                        model: {
                                                          value: lineSize.more3,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "more3",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.more3"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input": "more12",
                                                          type: "number",
                                                          name: "more12",
                                                          id: "more12",
                                                          label:
                                                            "Harga lebih dari 12",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "more12"
                                                          ),
                                                          "data-vv-as":
                                                            "harga lebih dari 3"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.more12,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "more12",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.more12"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4 pl-4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input":
                                                            "dropshipper",
                                                          type: "number",
                                                          name: "dropshipper",
                                                          id: "dropshipper",
                                                          label:
                                                            "Harga dropshipper",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "dropshipper"
                                                          ),
                                                          "data-vv-as":
                                                            "harga dropshipper"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.dropshipper,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "dropshipper",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.dropshipper"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input":
                                                            "gold_member",
                                                          type: "number",
                                                          name: "gold_member",
                                                          id: "gold_member",
                                                          label:
                                                            "Harga gold member",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "gold_member"
                                                          ),
                                                          "data-vv-as":
                                                            "harga gold member"
                                                        },
                                                        model: {
                                                          value:
                                                            lineSize.gold_member,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "gold_member",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.gold_member"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c("fg-input", {
                                                        attrs: {
                                                          required: true,
                                                          "for-input": "stock",
                                                          type: "number",
                                                          name: "stock",
                                                          id: "stock",
                                                          label: "Stok",
                                                          placeholder:
                                                            "Enter Name",
                                                          error: _vm.errors.first(
                                                            "stock"
                                                          ),
                                                          "data-vv-as": "Stok"
                                                        },
                                                        model: {
                                                          value: lineSize.stock,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              lineSize,
                                                              "stock",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "lineSize.stock"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "float-left",
                                attrs: {
                                  variant: !_vm.addProduct
                                    ? "primary"
                                    : "warning"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.addProduct = !_vm.addProduct
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: !_vm.addProduct ? "plus" : "times"
                                  }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      !_vm.addProduct
                                        ? "Tambah Warna Barang"
                                        : "Batal"
                                    )
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("save-data-button", {
                              attrs: {
                                disabled: _vm.saveButtonData.isLoading,
                                "is-create": _vm.$route.params.id !== undefined,
                                state:
                                  _vm.saveButtonData.isLoading &&
                                  _vm.saveButtonData.state === 1
                                    ? 2
                                    : _vm.saveButtonData.state,
                                "is-loading": _vm.saveButtonData.isLoading
                              }
                            })
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mb-5" },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("fg-input", { attrs: { label: "Kode" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.model.code))])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Name" } }, [
                        _vm.isFieldCode
                          ? _c("div", { staticClass: "form-row" }, [
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c("fg-input", {
                                    attrs: {
                                      required: true,
                                      "for-input": "Name",
                                      type: "text",
                                      name: "name",
                                      id: "Name",
                                      placeholder: "Enter Name"
                                    },
                                    model: {
                                      value: _vm.setFieldCode,
                                      callback: function($$v) {
                                        _vm.setFieldCode = $$v
                                      },
                                      expression: "setFieldCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "warning" },
                                      on: { click: _vm.batalFieldCode }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "times" }
                                      }),
                                      _vm._v(" Batal")
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "success" },
                                      on: { click: _vm.simpanFieldCode }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "save" }
                                      }),
                                      _vm._v(" Simpan")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _c(
                              "p",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.editFieldCode(_vm.model.name)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.model.name))]
                            )
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Kategori" } }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.model.category.category.name))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Active" } }, [
                        _c(
                          "p",
                          [
                            _c("l-switch", {
                              attrs: {
                                width: 30,
                                type: "primary",
                                "active-value": 1,
                                "inactive-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.changeSwitch(
                                    "isActive",
                                    "Available",
                                    _vm.model.isActive
                                  )
                                }
                              },
                              model: {
                                value: _vm.model.isActive,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "isActive", $$v)
                                },
                                expression: "model.isActive"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("fg-input", { attrs: { label: "Dibuat Oleh" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.model.createdBy.name))])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "DIperbarui Oleh" } }, [
                        _c("p", [_vm._v(_vm._s(_vm.model.lastUpdatedBy.name))])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Deskripsi Barang" } }, [
                        _c("p"),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.model.description !== null
                                ? _vm.model.description
                                : "-"
                            )
                          }
                        }),
                        _c("p")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "12" } }, [
                    _c("h3", { staticClass: "border-bottom" }, [
                      _c("strong", [_vm._v("Photo Barang")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("fg-input", { attrs: { label: "Photo 1" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ]
                          },
                          [
                            _vm.model.photo1 === null
                              ? _c(
                                  "label",
                                  {
                                    staticClass: "text-secondary top-padding-6"
                                  },
                                  [_vm._v("No photo submitted")]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      "max-width": "300px",
                                      display: "inline-block",
                                      "margin-right": "10px"
                                    }
                                  },
                                  [
                                    _c("b-img", {
                                      staticClass: "icon-large img-fluid",
                                      attrs: {
                                        src: _vm.getPath(_vm.model.photo1)
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("fg-input", { attrs: { label: "Photo 2" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ]
                          },
                          [
                            _vm.model.photo2 === null
                              ? _c(
                                  "label",
                                  {
                                    staticClass: "text-secondary top-padding-6"
                                  },
                                  [_vm._v("No photo submitted")]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      "max-width": "300px",
                                      display: "inline-block",
                                      "margin-right": "10px"
                                    }
                                  },
                                  [
                                    _c("b-img", {
                                      staticClass: "icon-large img-fluid",
                                      attrs: {
                                        src: _vm.getPath(_vm.model.photo2)
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("fg-input", { attrs: { label: "Photo 3" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ]
                          },
                          [
                            _vm.model.photo3 === null
                              ? _c(
                                  "label",
                                  {
                                    staticClass: "text-secondary top-padding-6"
                                  },
                                  [_vm._v("No photo submitted")]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      "max-width": "300px",
                                      display: "inline-block",
                                      "margin-right": "10px"
                                    }
                                  },
                                  [
                                    _c("b-img", {
                                      staticClass: "icon-large img-fluid",
                                      attrs: {
                                        src: _vm.getPath(_vm.model.photo3)
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("fg-input", { attrs: { label: "Photo 4" } }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "viewer", rawName: "v-viewer" }
                            ]
                          },
                          [
                            _vm.model.photo4 === null
                              ? _c(
                                  "label",
                                  {
                                    staticClass: "text-secondary top-padding-6"
                                  },
                                  [_vm._v("No photo submitted")]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      "max-width": "300px",
                                      display: "inline-block",
                                      "margin-right": "10px"
                                    }
                                  },
                                  [
                                    _c("b-img", {
                                      staticClass: "icon-large img-fluid",
                                      attrs: {
                                        src: _vm.getPath(_vm.model.photo4)
                                      }
                                    })
                                  ],
                                  1
                                )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3 mb-3" },
                _vm._l(_vm.model.category.product_color, function(color) {
                  return _c(
                    "b-col",
                    { key: color.id, attrs: { md: "12" } },
                    [
                      _c("fg-input", { attrs: { label: "Warna" } }, [
                        _c("p", [_vm._v(_vm._s(color.color.name))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "fg-input",
                        { attrs: { label: "Photo Barang / Warna" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                { name: "viewer", rawName: "v-viewer" }
                              ]
                            },
                            [
                              color.photo_color === null
                                ? _c(
                                    "label",
                                    {
                                      staticClass:
                                        "text-secondary top-padding-6"
                                    },
                                    [_vm._v("No photo submitted")]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        position: "relative",
                                        "max-width": "100px",
                                        display: "inline-block",
                                        "margin-right": "10px"
                                      }
                                    },
                                    [
                                      _c("b-img", {
                                        staticClass: "icon-large img-fluid",
                                        attrs: {
                                          src: _vm.getPath(color.photo_color)
                                        }
                                      })
                                    ],
                                    1
                                  )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "table-responsive" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.ShowModalAddSize(color)
                                }
                              }
                            },
                            [_vm._v("Tambah Ukuran")]
                          ),
                          _vm._v(" "),
                          _c("table", { staticClass: "table table-striped" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Ukuran")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Stock")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Min. Stock")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("unit")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Beli")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Jual")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Member")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Spesial Member")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Lebih 3")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Lebih 12")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Dropshipper")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Harga Gold Member")]),
                                _vm._v(" "),
                                _c("th")
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(color.product_size, function(size) {
                                return _c("tr", { key: size.id }, [
                                  _c("td", [_vm._v(_vm._s(size.size.name))]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            id: "popover-" + size.id,
                                            variant: "primary"
                                          }
                                        },
                                        [_vm._v(_vm._s(size.stock))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-popover",
                                        {
                                          attrs: {
                                            target: "popover-" + size.id,
                                            triggers: " focus"
                                          }
                                        },
                                        [
                                          [
                                            _c("strong", [
                                              _vm._v("Kosongkan Stok")
                                            ])
                                          ],
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mt-2",
                                              attrs: { variant: "danger" },
                                              on: {
                                                click: function($event) {
                                                  _vm.stockZero(size.id)
                                                }
                                              }
                                            },
                                            [_vm._v("Kosongkan sekarang!")]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        size.min_stock !== null
                                          ? size.min_stock
                                          : 0
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(size.unit))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(size.capital_price)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(size.selling_price)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(size.member_price)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatNumber(size.sm_price))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatNumber(size.more_3))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatNumber(size.more_12))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatNumber(size.dropshipper))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatNumber(size.gold_member))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "button",
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.showModal(size)
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "edit" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              })
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ),
              _vm._v(" "),
              _c("back-button")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "my-modal",
          attrs: {
            centered: "",
            "hide-footer": "",
            title: (_vm.model.id === "" ? "Tambah" : "Perbarui") + " Harga"
          }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doUpdated($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("fg-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.modelValidations.capitalPrice,
                        expression: "modelValidations.capitalPrice"
                      }
                    ],
                    attrs: {
                      required: true,
                      "for-input": "capitalPrice",
                      type: "number",
                      name: "capitalPrice",
                      id: "capitalPrice",
                      label: "Harga Modal",
                      placeholder: "Masukkan harga modal",
                      error: _vm.errors.first("capitalPrice"),
                      "data-vv-as": "harga modal"
                    },
                    model: {
                      value: _vm.data.capitalPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "capitalPrice", $$v)
                      },
                      expression: "data.capitalPrice"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "sellingPrice",
                      type: "number",
                      name: "sellingPrice",
                      id: "sellingPrice",
                      label: "Harga Jual",
                      placeholder: "Masukkan harga jual"
                    },
                    model: {
                      value: _vm.data.sellingPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "sellingPrice", $$v)
                      },
                      expression: "data.sellingPrice"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "min_stock",
                      type: "number",
                      name: "min_stock",
                      id: "min_stock",
                      label: "Minimal Stok",
                      placeholder: "Masukkan minimal stok"
                    },
                    model: {
                      value: _vm.data.min_stock,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "min_stock", $$v)
                      },
                      expression: "data.min_stock"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "memberPrice",
                      type: "number",
                      name: "memberPrice",
                      id: "memberPrice",
                      label: "Harga Member",
                      placeholder: "Masukkan harga member"
                    },
                    model: {
                      value: _vm.data.memberPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "memberPrice", $$v)
                      },
                      expression: "data.memberPrice"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "smPrice",
                      type: "number",
                      name: "smPrice",
                      id: "smPrice",
                      label: "Harga Spesial Member",
                      placeholder: "Masukkan harga spesial member"
                    },
                    model: {
                      value: _vm.data.smPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "smPrice", $$v)
                      },
                      expression: "data.smPrice"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "more3",
                      type: "number",
                      name: "more3",
                      id: "more3",
                      label: "Harga Lebih Dari 3",
                      placeholder: "Masukkan harga lebih dari 3"
                    },
                    model: {
                      value: _vm.data.more3,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "more3", $$v)
                      },
                      expression: "data.more3"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "more12",
                      type: "number",
                      name: "more12",
                      id: "more12",
                      label: "Harga lebih dari 12",
                      placeholder: "Masukkan harga lebih dari 12"
                    },
                    model: {
                      value: _vm.data.more12,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "more12", $$v)
                      },
                      expression: "data.more12"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "dropshipper",
                      type: "number",
                      name: "dropshipper",
                      id: "dropshipper",
                      label: "Harga dropshipper",
                      placeholder: "Masukkan harga dropshipper"
                    },
                    model: {
                      value: _vm.data.dropshipper,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "dropshipper", $$v)
                      },
                      expression: "data.dropshipper"
                    }
                  }),
                  _vm._v(" "),
                  _c("fg-input", {
                    attrs: {
                      "for-input": "gold_member",
                      type: "number",
                      name: "gold_member",
                      id: "gold_member",
                      label: "Harga gold member",
                      placeholder: "Masukkan harga gold member"
                    },
                    model: {
                      value: _vm.data.gold_member,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "gold_member", $$v)
                      },
                      expression: "data.gold_member"
                    }
                  }),
                  _vm._v(" "),
                  _c("save-data-button", {
                    attrs: {
                      disabled: _vm.saveButtonData.isLoading,
                      "is-create": _vm.$route.params.id !== undefined,
                      state:
                        _vm.saveButtonData.isLoading &&
                        _vm.saveButtonData.state === 1
                          ? 2
                          : _vm.saveButtonData.state,
                      "is-loading": _vm.saveButtonData.isLoading
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-3",
                      attrs: { variant: "warning" },
                      on: { click: _vm.hideModal }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "my-modal-photo-product",
          attrs: {
            centered: "",
            large: "",
            "hide-footer": "",
            title: "Photo Barang"
          }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmitProductPhoto($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("fg-input", {
                    attrs: {
                      "for-input": "name",
                      type: "text",
                      name: "name",
                      id: "name",
                      label: "Nama",
                      placeholder: "Masukkan nama barang",
                      rows: "10"
                    },
                    model: {
                      value: _vm.dataPhoto.name,
                      callback: function($$v) {
                        _vm.$set(_vm.dataPhoto, "name", $$v)
                      },
                      expression: "dataPhoto.name"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "" } }, [_vm._v("Deskripsi")]),
                  _vm._v(" "),
                  _c("vue-editor", {
                    model: {
                      value: _vm.dataPhoto.description,
                      callback: function($$v) {
                        _vm.$set(_vm.dataPhoto, "description", $$v)
                      },
                      expression: "dataPhoto.description"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        label: "Photo 1",
                        "for-input": "fileinputGroupFile",
                        error: _vm.errors.first("photo1")
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "custom-file" }, [
                          _c("input", {
                            ref: "photo1",
                            staticClass: "custom-file-input",
                            attrs: {
                              type: "file",
                              id: "fileinputGroupFile",
                              accept: "image/*",
                              name: "photo1"
                            },
                            on: { change: _vm.onFileSelectedPhoto1 }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              attrs: { for: "fileinputGroupFile" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dataPhoto.photo1 !== null
                                    ? _vm.dataPhoto.photo1.name
                                    : "Choose file"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataPhoto.photo1 !== null
                          ? _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text bg-danger text-white pointer",
                                  attrs: { title: "Clear Image" },
                                  on: { click: _vm.clearImagePhoto1 }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "times" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        label: "Photo 2",
                        "for-input": "fileinputGroupFile",
                        error: _vm.errors.first("photo2")
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "custom-file" }, [
                          _c("input", {
                            ref: "photo2",
                            staticClass: "custom-file-input",
                            attrs: {
                              type: "file",
                              id: "fileinputGroupFile",
                              accept: "image/*",
                              name: "photo2"
                            },
                            on: { change: _vm.onFileSelectedPhoto2 }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              attrs: { for: "fileinputGroupFile" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dataPhoto.photo2 !== null
                                    ? _vm.dataPhoto.photo2.name
                                    : "Choose file"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataPhoto.photo2 !== null
                          ? _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text bg-danger text-white pointer",
                                  attrs: { title: "Clear Image" },
                                  on: { click: _vm.clearImagePhoto2 }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "times" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        label: "Photo 3",
                        "for-input": "fileinputGroupFile",
                        error: _vm.errors.first("photo3")
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "custom-file" }, [
                          _c("input", {
                            ref: "photo3",
                            staticClass: "custom-file-input",
                            attrs: {
                              type: "file",
                              id: "fileinputGroupFile",
                              accept: "image/*",
                              name: "photo3"
                            },
                            on: { change: _vm.onFileSelectedPhoto3 }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              attrs: { for: "fileinputGroupFile" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dataPhoto.photo3 !== null
                                    ? _vm.dataPhoto.photo3.name
                                    : "Choose file"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataPhoto.photo3 !== null
                          ? _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text bg-danger text-white pointer",
                                  attrs: { title: "Clear Image" },
                                  on: { click: _vm.clearImagePhoto3 }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "times" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        label: "Photo 4",
                        "for-input": "fileinputGroupFile",
                        error: _vm.errors.first("photo4")
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "custom-file" }, [
                          _c("input", {
                            ref: "photo4",
                            staticClass: "custom-file-input",
                            attrs: {
                              type: "file",
                              id: "fileinputGroupFile",
                              accept: "image/*",
                              name: "photo4"
                            },
                            on: { change: _vm.onFileSelectedPhoto4 }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              attrs: { for: "fileinputGroupFile" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dataPhoto.photo4 !== null
                                    ? _vm.dataPhoto.photo4.name
                                    : "Choose file"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataPhoto.photo4 !== null
                          ? _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text bg-danger text-white pointer",
                                  attrs: { title: "Clear Image" },
                                  on: { click: _vm.clearImagePhoto4 }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "times" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "primary",
                        type: "submit",
                        disaled: _vm.isLoadingPhoto
                      }
                    },
                    [
                      _vm.isLoadingPhoto
                        ? _c("font-awesome-icon", {
                            attrs: { icon: "spinner", spin: "" }
                          })
                        : _c("font-awesome-icon", { attrs: { icon: "save" } }),
                      _vm._v(" Submit")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-left mr-3",
                      attrs: {
                        variant: "warning",
                        disaled: _vm.isLoadingPhoto
                      },
                      on: { click: _vm.hideProductModal }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "times" } }),
                      _vm._v(" Cancel")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "my-modal-photo-color-product",
          attrs: {
            centered: "",
            "hide-footer": "",
            title: "Photo Barang / Warna"
          }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmitProductPhotoColor($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        required: true,
                        label: "Warna",
                        "for-input": "color",
                        error: _vm.errors.first("color")
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.dataPhoto.productColor) +
                          "\n          "
                      ),
                      _c(
                        "el-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.modelValidations.productColor,
                              expression: "modelValidations.productColor"
                            }
                          ],
                          attrs: {
                            size: "large",
                            id: "color",
                            name: "color",
                            "data-vv-as": "color",
                            placeholder: "Pilih color"
                          },
                          model: {
                            value: _vm.dataPhoto.productColor,
                            callback: function($$v) {
                              _vm.$set(_vm.dataPhoto, "productColor", $$v)
                            },
                            expression: "dataPhoto.productColor"
                          }
                        },
                        _vm._l(_vm.model.category.product_color, function(
                          option
                        ) {
                          return _c("el-option", {
                            key: option.id,
                            attrs: {
                              value: option.id,
                              label: option.color.name
                            }
                          })
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        label: "Photo",
                        "for-input": "fileinputGroupFile",
                        error: _vm.errors.first("photoColor")
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "custom-file" }, [
                          _c("input", {
                            ref: "photoColor",
                            staticClass: "custom-file-input",
                            attrs: {
                              type: "file",
                              id: "fileinputGroupFile",
                              accept: "image/*",
                              name: "photoColor"
                            },
                            on: { change: _vm.onFileSelectedPhotoColor }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              attrs: { for: "fileinputGroupFile" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dataPhoto.photoColor !== null
                                    ? _vm.dataPhoto.photoColor.name
                                    : "Choose file"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataPhoto.photoColor !== null
                          ? _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text bg-danger text-white pointer",
                                  attrs: { title: "Clear Image" },
                                  on: { click: _vm.clearImagePhotoColor }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "times" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "primary",
                        type: "submit",
                        disabled: _vm.isLoadingPhotoColor
                      }
                    },
                    [
                      _vm.isLoadingPhotoColor
                        ? _c("font-awesome-icon", {
                            attrs: { icon: "spinner", spin: "" }
                          })
                        : _c("font-awesome-icon", { attrs: { icon: "save" } }),
                      _vm._v(" Submit")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-left mr-3",
                      attrs: {
                        variant: "warning",
                        disabled: _vm.isLoadingPhotoColor
                      },
                      on: { click: _vm.hideProductColorModal }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "times" } }),
                      _vm._v(" Cancel")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "my-modal-product-size-global",
          attrs: {
            centered: "",
            "hide-footer": "",
            title: "Ukuran Barang Global"
          }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmitProductSizeGlobal($event)
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        required: true,
                        label: "Warna",
                        "for-input": "color",
                        error: _vm.errors.first("color")
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.dataPhoto.productColor) +
                          "\n          "
                      ),
                      _c(
                        "el-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.modelValidations.productColor,
                              expression: "modelValidations.productColor"
                            }
                          ],
                          attrs: {
                            size: "large",
                            id: "color",
                            name: "color",
                            "data-vv-as": "color",
                            placeholder: "Pilih color"
                          },
                          model: {
                            value: _vm.dataPhoto.productColor,
                            callback: function($$v) {
                              _vm.$set(_vm.dataPhoto, "productColor", $$v)
                            },
                            expression: "dataPhoto.productColor"
                          }
                        },
                        _vm._l(_vm.model.category.product_color, function(
                          option
                        ) {
                          return _c("el-option", {
                            key: option.id,
                            attrs: {
                              value: option.id,
                              label: option.color.name
                            }
                          })
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fg-input",
                    {
                      attrs: {
                        label: "Photo",
                        "for-input": "fileinputGroupFile",
                        error: _vm.errors.first("photoColor")
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("div", { staticClass: "custom-file" }, [
                          _c("input", {
                            ref: "photoColor",
                            staticClass: "custom-file-input",
                            attrs: {
                              type: "file",
                              id: "fileinputGroupFile",
                              accept: "image/*",
                              name: "photoColor"
                            },
                            on: { change: _vm.onFileSelectedPhotoColor }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "custom-file-label",
                              attrs: { for: "fileinputGroupFile" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.dataPhoto.photoColor !== null
                                    ? _vm.dataPhoto.photoColor.name
                                    : "Choose file"
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataPhoto.photoColor !== null
                          ? _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text bg-danger text-white pointer",
                                  attrs: { title: "Clear Image" },
                                  on: { click: _vm.clearImagePhotoColor }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "times" }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "primary",
                        type: "submit",
                        disabled: _vm.isLoadingPhotoColor
                      }
                    },
                    [
                      _vm.isLoadingPhotoColor
                        ? _c("font-awesome-icon", {
                            attrs: { icon: "spinner", spin: "" }
                          })
                        : _c("font-awesome-icon", { attrs: { icon: "save" } }),
                      _vm._v(" Submit")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-left mr-3",
                      attrs: {
                        variant: "warning",
                        disabled: _vm.isLoadingPhotoColor
                      },
                      on: { click: _vm.hideProductColorModal }
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "times" } }),
                      _vm._v(" Cancel")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("fab", {
        attrs: {
          position: _vm.position,
          "bg-color": _vm.bgColor,
          actions: _vm.fabActions,
          "icon-size": "small"
        },
        on: {
          productModal: _vm.showProductModal,
          productCOlorModal: _vm.showProductColorModal,
          productSizeGlobalModal: _vm.showProductSizeGlobalModal
        }
      }),
      _vm._v(" "),
      _c("ModalAddSize", {
        ref: "modal-add-size",
        on: { getDetail: _vm.getDetail }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92fe1ea4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92fe1ea4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Products/Show.vue
// module id = CcRq
// module chunks = 4